import React from 'react';
import { withRouter } from "react-router-dom";

import Sharebar from './Sharebar';

class Header extends React.Component {
   // constructor(props) {
   //    super(props);
   //  }
    
    render(){
      const path = this.props.location.pathname.slice(1).replace(/-/g,' ');
      
      let wherelink;
      if(path == 'national news'){
         wherelink = 'Home » ' + path;
      }else{
         wherelink = path;
      }
       return (
          <div className="stuffHeader-container">
             {/* eslint-disable-next-line */}
             <a target="_blank" href="https://www.stuff.co.nz/" className="stuffHeader-container__logo" rel="noopener noreferrer"></a>
              <Sharebar />
            <div className="stuffHeader-container__stuff--darkgreycolorcolorbar"><span className="stuffHeader-container__stuff--darkgreycolorcolorbar--text">INDEPENDENT NEWSPAPERS LTD</span></div>
            <div className="stuffHeader-container__stuff--lightbluecolorcolorbar"><span className="stuffHeader-container__stuff--lightbluecolorcolorbar--text">{wherelink}</span></div>
          </div>
       );
    }
}

export default withRouter(Header);